import { useEffect, useState } from "react";

export function useScreenSize() {
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1281);
  
    useEffect(() => {
      const handleResize = () => {
        setIsLargeScreen(window.innerWidth >= 1281);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return isLargeScreen;
}